/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { type App } from '~/app';

import JsController from '../../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'Promo Tile with Icon');
    controller.addMountFunction(() => {
        mountComponent(controller);
    })

    return controller.init();
}

export function mountComponent( controller: JsController ) {
    const promoTilesWithIcon = document.querySelectorAll<HTMLElement>('.promo-tile-with-icon');

    for (const promoTileWithIcon of promoTilesWithIcon){
        const description = promoTileWithIcon.querySelector<HTMLElement>('.description');
        const readMoreButton = promoTileWithIcon.querySelector<HTMLElement>('.read-more-button');

        const isTextClamped = (elm: HTMLElement) => elm.scrollHeight > elm.clientHeight;

        if (description && readMoreButton){
            const readMore = readMoreButton.querySelector<HTMLElement>('.read-more-text');
            const readLess = readMoreButton.querySelector<HTMLElement>('.read-less-text');
            const chevron = readMoreButton.querySelector<HTMLElement>('.chevron-toggle');

            const readMoreLessToggle = () => {
                description.classList.toggle('line-clamp-3');
                readMore?.classList.toggle('hidden');
                readLess?.classList.toggle('hidden');
                chevron?.classList.toggle("rotate-180");
            }

            controller.addListener(readMoreButton, "click", readMoreLessToggle);

            const toggleReadMoreButton = () => {
                if (isTextClamped(description)) {
                    readMoreButton.classList.remove('hidden')
                } else {
                    readMoreButton.classList.add('hidden')
                }
            }

            toggleReadMoreButton();
            controller.addListener(window, "resize", toggleReadMoreButton);

        }

    }
}
